<template>
  <div>
    <div class="banner">
      <div class="headerReplacementStockPriceInfo"></div>
      <div class="banner-text">
        <b>ข้อมูลราคาหลักทรัพย์</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลราคาหลักทรัพย์</span>
          <span class="separator"></span>
          <span><b>ราคาหลักทรัพย์ย้อนหลัง</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <StockPriceInfoTabMenu />
      </div>

      <div class="row mb-3 justify-content-center align-items-center">
        <div class="col-12 col-md-6">
          <div class="card bg-white mx-auto mt-4 mb-5">
            <div class="card-header bg-black text-white text-center">
              เลือกช่วงวันที่
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <date-picker type="date" placeholder="วันที่เริ่ม" class="w-100 m-1" input-class="form-control"
                    value-type="format" format="YYYY-MM-DD" />
                </div>
                <div class="col-md-6">
                  <date-picker type="date" placeholder="วันที่สิ้นสุด" class="w-100 m-1" input-class="form-control"
                    value-type="format" format="YYYY-MM-DD" />
                </div>
              </div>
              <div class="row text-center">
                <div class="col">
                  <button type="button" class="w-50 btn btn-outline-primary">ค้นหา</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="mt-3 mb-3">ราคาหลักทรัพย์ย้อนหลังจาก : 19 ก.พ. 2567 ถึง 21 พ.ค. 2567</div>
      <table class="table mb-5">
        <thead>
          <tr class="table-dark">
            <th scope="col">วันที่</th>
            <th scope="col">ราคาเปิด</th>
            <th scope="col">สูงสุด</th>
            <th scope="col">ต่ำสุด</th>
            <th scope="col">ราคาปิด</th>
            <th scope="col">ปริมาณซื้อขาย (หุ้น)</th>
            <th scope="col">มูลค่าการซื้อขาย (บาท)</th>
          </tr>
        </thead>
        <thead>
          <tr class="table-secondary">
            <th scope="col"><b>ข้อมูลสรุป</b></th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col"></th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              <div><b>ก่อนหน้า</b></div>
              <div>2 สัปดาห์ ( 22 เมษายน 2567 ถึง 07 พฤษภาคม 2567 )</div>
            </th>
            <td>{{ financialData?.[0]?.year1 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year2 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>

          </tr>
          <tr>
            <th scope="row">
              <div><b>ก่อนหน้า</b></div>
              <div>ก่อนหน้า 4 สัปดาห์ ( 19 มีนาคม 2567 ถึง 19 เมษายน 2567 )</div>
            </th>
            <td>{{ financialData?.[0]?.year1 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year2 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
          </tr>

          <tr class="table-secondary">
            <th scope="row"><b>ข้อมูลราคาย้อนหลัง</b></th>
            <td>{{ financialData?.[0]?.year1 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year2 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
          </tr>
          <tr>
            <th scope="row">21 พฤษภาคม 2567</th>
            <td>{{ financialData?.[0]?.year1 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year2 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
            <td>{{ financialData?.[0]?.year3 || 'N/A' }}</td>
          </tr>
          <!-- Add more rows as needed -->
        </tbody>
      </table>
    </div>
  </div>
</template>
  
<script>
import StockPriceInfoTabMenu from '@/components/StockPriceInfoTabMenu.vue';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";
import DatePicker from 'vue2-datepicker';

export default {
  name: 'Info',
  components: {
    StockPriceInfoTabMenu, DatePicker
  },
  data() {
    return {
      financialData: null,
    };
  },
};
</script>
<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}

.card {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 8px;
}
</style>
  